import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import React from 'react';
import { ROOTINE_HELP_URL } from '../utils';
import RootineButton from './RootineButton';

export default function HelpCenterLink() {
  return (
    <RootineButton
      url={ROOTINE_HELP_URL}
      as="a"
      label="Help Center"
      variation="outline_light"
      size="small"
      hideIcon
      startIcon={<HelpOutlineIcon />}
      openNewTab
    />
  );
}
